import { createReducer, } from 'typesafe-actions';

import { shopCartOperations, } from '../shopCart';
import { combineReducers } from 'redux'

const cartItemsInitialState = {
    isError: false,
    errorDetails: {
        message: null,
        code: null,
        data: null,
    },
};

const cartItemsReducer = createReducer(cartItemsInitialState)
    .handleAction(shopCartOperations.cartItemsPost.request, (state) => ({  ...state, ...cartItemsInitialState, }))
    .handleAction(shopCartOperations.cartItemsPost.success, (state) => ({  ...state, ...cartItemsInitialState, }))
    .handleAction(shopCartOperations.cartItemsPost.failure, (state, { payload, }) => ({
        ...state,
        isError: true,
        errorDetails: {
            code: payload.code,
            message: payload.message,
            data: payload.data,
        },
    }));

export default combineReducers({
    cartItems: cartItemsReducer,
});
